import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Field, FieldAndResourcePart } from '®app/resource/edit/visible-fields';

@Component({
  selector: 'rl-add-field-button',
  templateUrl: './resource-edit-add-field-button.component.html',
  styleUrls: ['./resource-edit-add-field-button.component.scss'],
})
export class ResourceEditAddFieldButtonComponent {
  @Input() addToMainResourceEnabled: boolean;
  @Input() addToPartOfResourceEnabled: boolean;
  @Input() field: Field;
  @Input() hasPartOfResource: boolean;
  @Input() label: string;
  @Output() addedField = new EventEmitter<FieldAndResourcePart>();

  addField(isPartOfResource: boolean): void {
    this.addedField.emit({
      field: this.field,
      isPartOfResource,
    });
  }
}
